(() => {
  const cartAddUrl = () => window.theme?.routes?.cart_add_url || '/cart/add.js';

  const initProductPage = (root) => {
    if (!root || root.dataset.obpReady === 'true') return;
    root.dataset.obpReady = 'true';

    const preorder = root.dataset.obpPreorder === 'true';
    const preorderPreview = root.dataset.obpPreviewMode === 'true';

    const mainImage = root.querySelector('[data-obp-main-image]');
    const thumbnails = Array.from(root.querySelectorAll('[data-obp-thumb]'));
    const offers = Array.from(root.querySelectorAll('[data-obp-offer]'));
    const variantInput = root.querySelector('[data-obp-variant]');
    const currentPrice = root.querySelector('[data-obp-current-price]');
    const currentOriginal = root.querySelector('[data-obp-current-original]');
    const buyButton = root.querySelector('[data-obp-buy-button]');
    const mobileOriginal = root.querySelector('[data-obp-mobile-original]');
    const mobilePrice = root.querySelector('[data-obp-mobile-price]');
    const mobileOffer = root.querySelector('[data-obp-mobile-offer]');
    const desktopBuybar = root.querySelector('[data-obp-desktop-buybar]');
    const desktopPrice = root.querySelector('[data-obp-desktop-price]');
    const desktopOriginal = root.querySelector('[data-obp-desktop-original]');
    const desktopOffer = root.querySelector('[data-obp-desktop-offer]');
    const desktopBuyButton = root.querySelector('[data-obp-desktop-buy]');
    const buyErrorWrapper = root.querySelector('.product-form__error-message-wrapper');
    const buyError = buyErrorWrapper?.querySelector('.product-form__error-message');
    const preorderPreviewHint = root.querySelector('[data-obp-preorder-preview-hint]');
    const stationOffers = Array.from(root.querySelectorAll('[data-obp-station-capable]'));
    const stationSelector = root.querySelector('[data-obp-station-selector]');
    const stationCount = root.querySelector('[data-obp-station-count]');
    const stationMinus = root.querySelector('[data-obp-station-minus]');
    const stationPlus = root.querySelector('[data-obp-station-plus]');
    const includedStation = root.querySelector('[data-obp-included-station]');
    const includedStationText = root.querySelector('[data-obp-included-station-text]');
    const includedProtector = root.querySelector('[data-obp-included-protector]');
    let stationQuantity = 1;
    let paypalSyncTimer;

    const syncPayPalAmount = (formattedPrice) => {
      const normalizedPrice = String(formattedPrice || '')
        .replace(/[^0-9,.-]/g, '')
        .replace(/\./g, '')
        .replace(',', '.');
      const amount = Number.parseFloat(normalizedPrice);
      if (!Number.isFinite(amount)) return;

      document.querySelectorAll('[data-pp-message][data-pp-placement="product"]').forEach((message) => {
        if (Number(message.getAttribute('data-pp-amount')) !== amount) {
          message.setAttribute('data-pp-amount', amount.toFixed(2));
        }
      });
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        thumbnails.forEach((item) => item.classList.remove('is-active'));
        thumbnail.classList.add('is-active');
        if (!mainImage) return;

        mainImage.style.opacity = '0';
        window.setTimeout(() => {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = thumbnail.dataset.image;
          mainImage.alt = thumbnail.dataset.alt || '';
          mainImage.style.opacity = '1';
        }, 150);
      });
    });

    const euroValue = (value) => Number(String(value || '').replace(/[^0-9,.-]/g, '').replace('.', '').replace(',', '.')) || 0;

    const getStationValue = (offer, prefix, quantity) => offer?.getAttribute(`data-${prefix}-${quantity}`) || '';

    const updateStationOffers = (nextQuantity) => {
      if (!stationOffers.length) return;
      stationQuantity = Math.min(5, Math.max(1, Number(nextQuantity) || 1));

      if (stationCount) stationCount.textContent = String(stationQuantity);
      if (stationMinus) stationMinus.disabled = stationQuantity <= 1;
      if (stationPlus) stationPlus.disabled = stationQuantity >= 5;
      if (includedStationText) {
        includedStationText.textContent = `${stationQuantity} Original-${stationQuantity === 1 ? 'Ladestation' : 'Ladestationen'}`;
      }

      let selectedStationOffer = null;
      stationOffers.forEach((offer) => {
        const offerKind = offer.dataset.offerKind || 'station';
        const price = getStationValue(offer, 'price', stationQuantity) || offer.dataset.price;
        const original = getStationValue(offer, 'original', stationQuantity);
        const rawPrice = Number(getStationValue(offer, 'price-cents', stationQuantity));
        const rawOriginal = Number(getStationValue(offer, 'original-cents', stationQuantity));
        const saving = Math.max(0, offer.hasAttribute('data-price-cents-1') ? (rawOriginal - rawPrice) / 100 : euroValue(original) - euroValue(price));
        const stationCopy = offer.querySelector('[data-obp-station-offer-copy]');
        const stationOriginal = offer.querySelector('[data-obp-station-original]');
        const stationPrice = offer.querySelector('[data-obp-station-price]');
        const stationSaving = offer.querySelector('[data-obp-station-saving]');

        offer.dataset.price = price;
        offer.dataset.original = original;
        if (offerKind === 'complete') {
          offer.dataset.short = stationQuantity === 1
            ? 'All-in-Set'
            : `All-in-Set mit ${stationQuantity} Ladestationen`;
          if (stationCopy) {
            stationCopy.textContent = root.classList.contains('obp-compact') ? `Startpaket + ${stationQuantity} Ladestation${stationQuantity > 1 ? 'en' : ''} + Displayschutz im 2er-Set` : `Gerät + Familien-App + Originalkabel + ${stationQuantity} ${stationQuantity === 1 ? 'Ladestation' : 'Ladestationen'} + Displayschutzfolie im 2er-Set. Jede weitere Ladestation 29,90 €.`;
          }
        } else {
          offer.dataset.short = stationQuantity === 1
            ? 'Set mit Ladestation'
            : `Set mit ${stationQuantity} Ladestationen`;
          if (stationCopy) {
            stationCopy.textContent = root.classList.contains('obp-compact') ? `Startpaket + ${stationQuantity} Original-Ladestation${stationQuantity > 1 ? 'en' : ''}` : `Gerät + Familien-App + Originalkabel + ${stationQuantity} ${stationQuantity === 1 ? 'Ladestation' : 'Ladestationen'}. Jede weitere Ladestation 29,90 €.`;
          }
        }
        if (stationOriginal) { stationOriginal.textContent = original; stationOriginal.hidden = saving <= 0; stationOriginal.style.display = saving > 0 ? '' : 'none'; }
        if (stationPrice) stationPrice.textContent = price;
        if (stationSaving) { stationSaving.hidden = saving <= 0; stationSaving.style.display = saving > 0 ? '' : 'none'; }
        if (stationSaving) stationSaving.textContent = `${saving.toLocaleString('de-DE', { style: 'currency', currency: root.dataset.obpCurrency || 'EUR', minimumFractionDigits: saving % 1 ? 2 : 0, maximumFractionDigits: 2 })} sparen`;
        if (offer.classList.contains('is-selected')) selectedStationOffer = offer;
      });

      if (selectedStationOffer) selectOffer(selectedStationOffer);
    };

    const selectOffer = (offer) => {
      if (preorderPreviewHint) preorderPreviewHint.hidden = true;
      offers.forEach((item) => {
        const selected = item === offer;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
      });

      const isStationSet = stationOffers.includes(offer);
      const offerKind = offer.dataset.offerKind || 'base';
      if (stationSelector) stationSelector.hidden = !isStationSet;
      if (includedStation) includedStation.hidden = !isStationSet;
      if (includedProtector) includedProtector.hidden = offerKind !== 'complete';
      if (includedStationText) {
        includedStationText.textContent = `${stationQuantity} Original-${stationQuantity === 1 ? 'Ladestation' : 'Ladestationen'}`;
      }
      if (variantInput) variantInput.value = offer.dataset.variantId;
      if (currentPrice) currentPrice.textContent = offer.dataset.price;
      if (currentOriginal) { currentOriginal.textContent = offer.dataset.original || ''; currentOriginal.style.display = euroValue(offer.dataset.original) > euroValue(offer.dataset.price) ? '' : 'none'; }
      syncPayPalAmount(offer.dataset.price);
      window.clearTimeout(paypalSyncTimer);
      paypalSyncTimer = window.setTimeout(() => syncPayPalAmount(offer.dataset.price), 800);
      if (mobilePrice) mobilePrice.textContent = offer.dataset.price;
      if (mobileOriginal) { mobileOriginal.textContent = offer.dataset.original || ''; mobileOriginal.style.display = euroValue(offer.dataset.original) > euroValue(offer.dataset.price) ? 'block' : 'none'; }
      if (mobileOffer) {
        const mobileLabel = offer.dataset.short.replace(/^One Button Phone$/, 'Startpaket').replace(/^Set mit Ladestation/, 'Mit Ladestation');
        mobileOffer.textContent = preorder ? `${mobileLabel} · nächste Lieferung` : mobileLabel;
      }

      const extraAvailable = !isStationSet || stationQuantity === 1 || offer.dataset.extraAvailable === 'true';
      const available = (preorder || offer.dataset.available === 'true') && extraAvailable;
      if (buyButton) {
        buyButton.disabled = !available;
        buyButton.textContent = available
          ? (preorder
            ? 'Jetzt 30 € sparen & bestellen'
            : `${root.classList.contains('obp-compact') ? 'Jetzt bestellen' : 'One Button Phone bestellen'} – ${offer.dataset.price}`)
          : 'Derzeit nicht verfügbar';
      }
      if (desktopPrice) desktopPrice.textContent = offer.dataset.price;
      if (desktopOriginal) { desktopOriginal.textContent = offer.dataset.original || ''; desktopOriginal.style.display = euroValue(offer.dataset.original) > euroValue(offer.dataset.price) ? '' : 'none'; }
      if (desktopOffer) desktopOffer.textContent = offer.dataset.short;
      if (desktopBuyButton) {
        desktopBuyButton.disabled = !available;
        desktopBuyButton.textContent = available
          ? (preorder ? 'Jetzt 30 € sparen & bestellen' : 'In den Warenkorb')
          : 'Derzeit nicht verfügbar';
        desktopBuyButton.setAttribute(
          'aria-label',
          available
            ? (preorder
              ? `${offer.dataset.short} mit 30 Euro Preisvorteil bestellen`
              : `${offer.dataset.short} für ${offer.dataset.price} in den Warenkorb legen`)
            : `${offer.dataset.short} ist derzeit nicht verfügbar`
        );
      }
    };

    offers.forEach((offer) => {
      offer.addEventListener('click', () => selectOffer(offer));
    });

    stationMinus?.addEventListener('click', () => updateStationOffers(stationQuantity - 1));
    stationPlus?.addEventListener('click', () => updateStationOffers(stationQuantity + 1));

    const queryQuantity = Number(new URLSearchParams(window.location.search).get('ladeplaetze'));
    updateStationOffers(queryQuantity >= 1 && queryQuantity <= 5 ? queryQuantity : 1);

    const requestedPackage = new URLSearchParams(window.location.search).get('paket');
    const linkedOffer = ['station', 'complete'].includes(requestedPackage) ? offers.find((offer) => offer.dataset.offerKind === requestedPackage) : null;
    const selectedOffer = linkedOffer || offers.find((offer) => offer.classList.contains('is-selected')) || offers[0];
    if (selectedOffer) selectOffer(selectedOffer);

    desktopBuyButton?.addEventListener('click', () => {
      if (desktopBuyButton.disabled || desktopBuyButton.classList.contains('loading')) return;
      buyButton?.click();
    });

    if (buyButton && desktopBuyButton) {
      const syncDesktopLoadingState = () => {
        const loading = buyButton.classList.contains('loading');
        desktopBuyButton.classList.toggle('loading', loading);
        if (loading) {
          desktopBuyButton.setAttribute('aria-busy', 'true');
        } else {
          desktopBuyButton.removeAttribute('aria-busy');
        }
      };
      const buyButtonObserver = new MutationObserver(syncDesktopLoadingState);
      buyButtonObserver.observe(buyButton, {
        attributes: true,
        attributeFilter: ['class', 'aria-busy']
      });
    }

    if (desktopBuybar && buyButton) {
      const desktopViewport = window.matchMedia('(min-width: 901px)');
      const changePackage = document.createElement('button');
      changePackage.type = 'button';
      changePackage.className = 'obp-pdp__desktop-change';
      changePackage.textContent = 'Paket ändern';
      desktopBuybar.querySelector('.obp-pdp__desktop-buybar-price')?.before(changePackage);
      changePackage.addEventListener('click', () => {
        const target = root.querySelector('[data-obp-offers]');
        target?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        target?.querySelector('[aria-checked="true"]')?.focus({ preventScroll: true });
      });
      const updateDesktopBuybar = () => {
        const rect = buyButton.getBoundingClientRect();
        const mainVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
        const visible = desktopViewport.matches && !mainVisible;
        desktopBuybar.classList.toggle('is-visible', visible);
        desktopBuybar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        desktopBuybar.toggleAttribute('inert', !visible);
        document.body.classList.toggle('obp-desktop-buybar-visible', visible);
      };
      let scheduled = false;
      const scheduleUpdate = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; updateDesktopBuybar(); });
      };
      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate);
      if ('ResizeObserver' in window) new ResizeObserver(scheduleUpdate).observe(root);
      desktopViewport.addEventListener?.('change', scheduleUpdate);
      updateDesktopBuybar();
    }

    buyButton?.addEventListener('click', async () => {
      if (buyButton.disabled || buyButton.classList.contains('loading')) return;
      if (preorderPreview) {
        if (preorderPreviewHint) preorderPreviewHint.hidden = false;
        return;
      }
      const selected = offers.find((offer) => offer.classList.contains('is-selected'));
      const variantId = Number(selected?.dataset.variantId || variantInput?.value);
      if (!variantId) return;

      const preorderProperties = preorder
        ? { Lieferhinweis: 'Geliefert in 1–3 Tagen' }
        : null;
      const items = [{
        id: variantId,
        quantity: 1,
        ...(preorderProperties ? { properties: preorderProperties } : {})
      }];
      if (stationOffers.includes(selected) && stationQuantity > 1) {
        const extraVariantId = Number(selected.dataset.extraStationVariantId);
        if (!extraVariantId) return;
        items.push({
          id: extraVariantId,
          quantity: stationQuantity - 1,
          ...(preorderProperties ? { properties: preorderProperties } : {})
        });
      }

      buyButton.classList.add('loading');
      buyButton.setAttribute('aria-busy', 'true');
      if (buyErrorWrapper) buyErrorWrapper.hidden = true;

      try {
        const response = await fetch(cartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });
        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'Das Produkt konnte nicht hinzugefügt werden.');
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: { product: result.items?.[0] || result }
        }));
        window.setTimeout(() => document.getElementById('Cart-Drawer')?.open(), 100);
      } catch (error) {
        if (buyErrorWrapper && buyError) {
          buyError.textContent = error.message || 'Bitte versuchen Sie es erneut.';
          buyErrorWrapper.hidden = false;
        }
      } finally {
        buyButton.classList.remove('loading');
        buyButton.removeAttribute('aria-busy');
      }
    });
  };

  const initProductVideo = (video) => {
    if (video.dataset.obpVideoReady === 'true') return;
    video.dataset.obpVideoReady = 'true';

    const button = video.querySelector('[data-obp-video-play]');
    const videoId = video.dataset.videoId;
    if (!button || !videoId) return;

    button.addEventListener('click', () => {
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
      iframe.title = button.getAttribute('aria-label') || 'One Button Phone Produktvideo';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      video.replaceChildren(iframe);
    }, { once: true });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-obp-pdp-main]').forEach(initProductPage);
    scope.querySelectorAll('[data-obp-product-video]').forEach(initProductVideo);

    scope.querySelectorAll('[data-obp-scroll-buy]').forEach((button) => {
      if (button.dataset.obpScrollReady === 'true') return;
      button.dataset.obpScrollReady = 'true';
      button.addEventListener('click', () => {
        document.querySelector('[data-obp-offers]')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

(()=>{
const root=document.querySelector('[data-obp-pdp-main].obp-compact');
if(!root||root.dataset.obpMobileGalleryReady)return;
const old=root.querySelector('.obp-pdp__gallery');
const copy=root.querySelector('.obp-pdp__product-copy');
const grid=root.querySelector('.obp-pdp__product-grid');
if(!old||!copy||!grid)return;
root.dataset.obpMobileGalleryReady='true';
const intro=document.createElement('div');intro.className='obp-mobile-intro';
const moved=['.obp-pdp__kicker','h1','.obp-pdp__lead'].map(selector=>{
const element=copy.querySelector(selector);if(!element)return null;
const anchor=document.createTextNode('');element.before(anchor);return {element,anchor};
}).filter(Boolean);
grid.prepend(intro);
const items=Array.from(old.querySelectorAll('[data-obp-thumb]')).map(b=>({src:b.dataset.image,alt:b.dataset.alt,thumb:b.querySelector('img').src}));
const gallery=document.createElement('section');gallery.className='obp-mobile-gallery';gallery.setAttribute('aria-label','Produktbilder');
const track=document.createElement('div');track.className='obp-mobile-gallery-track';track.tabIndex=0;track.setAttribute('aria-label','Produktbilder – nach links oder rechts wischen');
const row=document.createElement('div');row.className='obp-mobile-gallery-controls';
const prev=document.createElement('button');prev.type='button';prev.textContent='‹';prev.setAttribute('aria-label','Vorheriges Produktbild');
const next=document.createElement('button');next.type='button';next.textContent='›';next.setAttribute('aria-label','Nächstes Produktbild');
const counter=document.createElement('span');counter.setAttribute('aria-live','polite');
row.append(prev,counter,next);
const thumbs=document.createElement('div');thumbs.className='obp-mobile-gallery-thumbs';
const dialog=document.createElement('dialog');dialog.className='obp-mobile-gallery-dialog';dialog.setAttribute('aria-label','Produktbild vergrößert');
const close=document.createElement('button');close.type='button';close.textContent='×';close.setAttribute('aria-label','Vergrößerte Ansicht schließen');
const large=document.createElement('img');dialog.append(close,large);document.body.append(dialog);
let active=0,focusBack;
function update(i){active=i;counter.textContent=`${i+1} / ${items.length}`;Array.from(thumbs.children).forEach((b,j)=>b.setAttribute('aria-pressed',String(i===j)));}
function go(i){i=Math.max(0,Math.min(items.length-1,i));track.scrollTo({left:i*track.clientWidth,behavior:'smooth'});}
items.forEach((item,i)=>{
 const slide=document.createElement('button');slide.type='button';slide.className='obp-mobile-gallery-slide';slide.setAttribute('aria-label',`Bild ${i+1} vergrößern: ${item.alt}`);
 const img=document.createElement('img');img.loading=i===0?'eager':'lazy';img.decoding='async';img.src=item.src;img.alt=item.alt;img.draggable=false;slide.append(img);track.append(slide);
 slide.addEventListener('click',()=>{if(dragged){dragged=false;return;}focusBack=slide;large.src=item.src;large.alt=item.alt;dialog.showModal();close.focus();});
 const thumb=document.createElement('button');thumb.type='button';thumb.setAttribute('aria-label',`Produktbild ${i+1} anzeigen`);const ti=document.createElement('img');ti.src=item.thumb;ti.alt='';thumb.append(ti);thumb.addEventListener('click',()=>go(i));thumbs.append(thumb);
});
let startX=0,dragged=false;
track.addEventListener('pointerdown',e=>{startX=e.clientX;dragged=false});track.addEventListener('pointermove',e=>{if(e.buttons&&Math.abs(e.clientX-startX)>10)dragged=true});
track.addEventListener('pointerup',e=>{const d=e.clientX-startX;if(e.pointerType==='mouse'&&Math.abs(d)>35){dragged=true;go(active+(d<0?1:-1));}});
track.addEventListener('scroll',()=>track.clientWidth&&update(Math.max(0,Math.min(items.length-1,Math.round(track.scrollLeft/track.clientWidth)))),{passive:true});
track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(active+(e.key==='ArrowRight'?1:-1))}});
prev.addEventListener('click',()=>go(active-1));next.addEventListener('click',()=>go(active+1));
close.addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>focusBack?.focus());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});
gallery.append(track,row,thumbs);old.after(gallery);update(0);
const mobile=window.matchMedia('(max-width:749px)');
function syncLayout(){
if(mobile.matches){moved.forEach(({element})=>intro.append(element));root.classList.add('obp-mobile-gallery-ready');requestAnimationFrame(()=>track.scrollTo({left:active*track.clientWidth,behavior:'instant'}));}
else{if(dialog.open)dialog.close();moved.forEach(({element,anchor})=>anchor.after(element));root.classList.remove('obp-mobile-gallery-ready');}
}
mobile.addEventListener('change',syncLayout);syncLayout();
})();

